export default __webpack_public_path__ + "static/media/bg-pentagon.1ad6d365.svg";